import { Typography } from 'antd';

interface IDelegationInfoTooltipLabelProps {
  label: string;
  name?: string;
  surname?: string;
  fiscalCode?: string;
}

/**
 * Componente per mostrare il dato del titolare/procuratore nel
 * tooltip relativo. Gestisce le logiche di visualizzazione,
 * in base alla presenza o meno dei dati.
 */
export function DelegationInfoTooltipLabel(
  props: IDelegationInfoTooltipLabelProps,
) {
  const { label, name, surname, fiscalCode } = props;

  if (!name && !surname && !fiscalCode) {
    return null;
  }

  const fullName = [name, surname].filter(Boolean).join(' ').trim();
  const fiscalCodeText = fiscalCode ? `(${fiscalCode})` : '';

  const fullLabel =
    fullName || fiscalCodeText ? `${fullName} ${fiscalCodeText}`.trim() : null;

  if (!fullLabel) {
    return null;
  }

  return (
    <Typography.Text>
      <strong>{label}:</strong> {fullLabel}
    </Typography.Text>
  );
}
